/* Copyright (C) mroads, LLC - All Rights Reserved
 * Unauthorized copying of this file, via any medium is strictly prohibited
 * Proprietary and confidential
 * Written by Premsagar Choudhary <premsagar.choudhary@mroads.com>, March 2021
 * @format
 * @flow
 */

import { REHYDRATE } from 'redux-persist';
import { ActionTypes } from '../constants';

const defaults: State = {
  data: {
    revenueCenters: [],
    premise: false,
  },
};

export interface ActionType {
  type: string;
  payload: any;
}

export default (state: State = defaults, action: ActionType) => {
  switch (action.type) {
    case ActionTypes.UPDATE_FILTERS: {
      return {
        ...state,
        data: {
          ...state.data,
          ...action.payload,
        },
      };
    }
    case REHYDRATE: {
      if (
        action.payload &&
        action.payload.teamshareFilterPersist &&
        action.payload.teamshareFilterPersist.data
      ) {
        return { ...state, ...action.payload.teamshareFilterPersist };
      }
      return { ...defaults };
    }
    default:
      return state;
  }
};
